<template>
    <div>
        <div class="overlay" v-show="busy">
        <div class="loader">
            <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            </div>
        </div>
        </div>
        <img class="bannerImg" src="./assets/shopify-kotobee.png"/>
        <div id="nav">
            <router-link to="/">Summary</router-link> |
            <router-link to="/linking">Linked Products</router-link> |
            <router-link to="/pricing">Pricing</router-link> |
            <router-link to="/howtouse">How to Use</router-link> |
            <router-link to="/settings">Settings</router-link>
        </div>
        <router-view/>
    </div>
</template>
<script>
export default {
  computed: {
    busy: function() {
      return this.$store.state.busy;
    }
  },
  mounted: function() {
  }
}
</script>
<style>
@media(max-width:500px){
    .bannerImg{
        display: none;
    }
}

.bannerImg{
    margin: 30px auto;
}

#nav {
  xpadding: 30px;
  color:#eee;
}

#nav a {
  xfont-weight: bold;
  color: #2c3e50;
  margin:0 6px;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255,255,255,.7);
}
.overlay .loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 80px;
  height: 80px;
  margin: auto;
}
/**
 * Pure CSS Loader
 * https://loading.io/css/
 */
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #000;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
